export const listMarkup = function (item) {
  return `
  <div class="product-card">
  <a class="link__container" href="/product-details.html?${item.productID}" >
  <div class="product-card__image">
    <img src="/img/product-clean/${item.images[0]}.webp" alt="" />
  </div>
  <div class="product-card__info">
    <div class="product-card__feature">${
      item.features ? item.features : item.material
    }</div>
    <h2 class="product-card__title">${item.title} ${item.category}</h2>

    <a href="/product-details.html?${
      item.productID
    }" class="product-card__button">Know More</a>
  </div>
  </a>
</div>
  `;
};

export const listPageMarkup = function (range, type) {
  return `
  <div class="list-page__cover cover-template-1__wrapper">
  <h1 class="list-page__heading cover-template-1__heading">
    <span class="list-page__sub-head cover-template-1__sub-head">
      ${range}
    </span>
    <span class="list-page__main-head cover-template-1__main-head">
      ${type}
    </span>
  </h1>
  </div>

  <div class="product-list__content">
  <div class="product-list__wrapper"></div>
  </div>`;
};
